import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-eclipse";

import { CanDeactivateGuard } from "./blogs/can-deactivate.guard";

import {
  COMPILER_OPTIONS,
  CompilerFactory,
  Compiler,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NO_ERRORS_SCHEMA,
} from "@angular/core";

import {
  BrowserModule,
  provideClientHydration,
} from "@angular/platform-browser";
import {
  AppComponent,
  ConfirmDirective,
  ConfirmModalComponent,
} from "./app.component";
// import { NgDragDropModule } from "ng-drag-drop";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { LoginActivate, RoleGuard } from "./services/LoginActivate";
import { PagesComponent } from "./views/pages/pages.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
// import { ResizableModule } from "angular-resizable-element";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpRequest,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AddEditPageComponent } from "./views/pages/add-edit-page/add-edit-page.component";
import { ModuleService } from "./services/module.service";
import { TextFieldModule } from "@angular/cdk/text-field";
import { BlockUIModule } from "ng-block-ui";
import { BlockUIHttpModule } from "ng-block-ui/http";
import { ConfirmationPopoverModule } from "angular-confirmation-popover";
import { PopoverModule } from "ngx-bootstrap/popover";
import { LoginComponent } from "./views/login/login.component";
import { MatDialogModule as MatDialogModule } from "@angular/material/dialog";

import {
  MainComponent,
  ThemeCalenderComponent,
} from "./views/main/main.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ColorPickerModule } from "ngx-color-picker";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { ComponentsTemplatesComponent } from "./views/components-templates/components-templates.component";
// import { FlexLayoutModule } from "@angular/flex-layout";
import { MediaManagerComponent } from "./views/media-manager/media-manager.component";
import { AuthInterceptorService } from "./services/auth-interceptor.service";
import { NgxDropzoneModule } from "ngx-dropzone";
import { AddFolderDialogComponent } from "./views/media-manager/add-folder-dialog/add-folder-dialog.component";
import { ViewFileComponent } from "./views/media-manager/view-file/view-file.component";
import { ModalModule } from "ngx-bootstrap/modal";
// import { AceEditorModule } from "ng2-ace-editor";
import { AceEditorModule } from "ngx-ace-editor-wrapper";
import "brace";
import "brace/mode/javascript";
import "brace/mode/css";
import "brace/theme/eclipse";
import { ReleaseManagerComponent } from "./views/release-manager/release-manager.component";
import { MatExpansionModule } from "@angular/material/expansion";

// import { AddEditUserComponent } from './users-management/add-edit-user/add-edit-user.component';
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
// import { ParticlesModule } from "ngx-particle";
import { BlogsArticlesComponent } from "./views/blogs-articles/blogs-articles.component";
import { AddEditBlogComponent } from "./views/blogs-articles/add-edit-blog/add-edit-blog.component";
import { AddEditBlogCategoryComponent } from "./views/blogs-articles/add-edit-blog-category/add-edit-blog-category.component";
// import { NgxParticlesModule } from "@tsparticles/angular";
import { MaterialModule } from "./material.module";
import { SharedModule } from "./shared/shared.module";
import { UsersPermissionsComponent } from "./views/users-permissions/users-permissions.component";
import { PermissionsComponent } from "./views/users-permissions/permissions/permissions.component";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { AddEditRolesComponent } from "./views/users-permissions/permissions/add-edit-roles/add-edit-roles.component";
// import { NgxNewstickerAlbeModule } from "ngx-newsticker-albe";
import { TabsModule } from "ngx-bootstrap/tabs";
import { MatTableModule } from "@angular/material/table";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { AddEditPageTemplateComponent } from "./views/page-templates/add-edit-page-templates/add-edit-page-template.component";
import { PageTemplatesComponent } from "./views/page-templates/page-templates.component";
// import { GridsterModule } from "angular-gridster2";
import { MenusComponent } from "./views/menus/menus.component";
import { AddEditMenuComponent } from "./views/menus/add-edit-menu/add-edit-menu.component";
import { ChildsMenuComponent } from "./views/menus/childs-menu/childs-menu.component";
import { DashboardComponent } from "./views/dashboard/dashboard.component";
// import { ChartsModule } from "ng2-charts";
// import { NgxImageEditorModule } from "ngx-image-editor";
import { NgxSummernoteModule } from "ngx-summernote";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { TranslationComponent } from "./views/translation/translation.component"; //abdullah nassar
import { MomentModule } from "ngx-moment";
import { SiteThemesComponent } from "./views/site-themes/site-themes.component";
import { ThemeDetailsComponent } from "./views/site-themes/theme-details/theme-details.component";
import { AddEditThemeNameComponent } from "./views/site-themes/add-edit-theme-name/add-edit-theme-name.component";
import { DataSourceComponent } from "./views/data-source/data-source.component";
import { AddEditDataSorceComponent } from "./views/data-source/AddEdit-data-sorce/AddEdit-data-sorce.component";
// import { CustomFormsModule } from "ng2-validation";
import { RolesManagerComponent } from "./views/users-permissions/roles-manager/roles-manager.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { RolePermissionDirective } from "./views/role-permission.directive";
import { Error_403Component } from "./views/error_403/error_403.component";
import { SnotifyModule, SnotifyService, ToastDefaults } from "ng-snotify";
import { RolesDialogeComponent } from "./views/roles-dialoge/roles-dialoge.component";
import { AppPageChildsMenuComponent } from "./views/pages/add-edit-page/app-page-childs-menu/app-page-childs-menu.component";
import { ComponentPageComponent } from "./views/component-page/component-page.component";
import { AddEditComponentComponent } from "./views/component-page/add-edit-component/add-edit-component.component";
import { ComponentsPrewiewComponent } from "./views/components-prewiew/components-prewiew.component";
import { CompilerComponent } from "./compiler/compiler.component";
import { SanitizeHtmlPipe } from "./shared/filter-pipe/filter.pipe";
import { SummernoteComponent } from "./shared/summernote/summernote.component";
import { DuplicatedFileComponent } from "./views/media-manager/Duplicated-file/Duplicated-file.component";
import { TestDatasourceComponent } from "./views/data-source/test-datasource/test-datasource.component";
import { CookieModule, CookieService } from "ngx-cookie";
// import {CookieService } from "ngx-cookie-service"
import { EmailTemplateComponent } from "./views/email-template/email-template.component";
import { AddEditEmailTemplateComponent } from "./views/email-template/add-edit-email-template/add-edit-email-template.component";
import { NotificationsComponent } from "./views/notifications/notifications.component";
import { AddNotificationsComponent } from "./views/notifications/add-notifications/add-notifications.component";
import { AddEditGroupsComponent } from "./shared/add-edit-groups/add-edit-groups.component";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { SubmitFormsComponent } from "./views/submit-forms/submit-forms.component";
import { ViewBuilderComponent } from "./views/view-builder/view-builder.component";
import { ComponentPositioningComponent } from "./views/view-builder/component-positioning/component-positioning.component";
import { BlockSettingsComponent } from "./views/view-builder/block-settings/block-settings.component";
// import { CommonSettingLibModule } from '../assets/bundels/common-setting-component-lib';
import { SettingComponent } from "./views/view-builder/setting/setting.component";
import { AddPageTitleComponent } from "./views/view-builder/add-page-title/add-page-title.component";
import { AddContainerComponent } from "./views/view-builder/add-container/add-container.component";
import { AddRowComponent } from "./views/view-builder/add-row/add-row.component";
import { SubmittedFormsComponent } from "./views/submitted-forms/submitted-forms.component";
import { AdvanceSearchDialogComponent } from "./catalog/advance-search-dialog/advance-search-dialog.component";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
// import { NgxParticlesModule } from "@tsparticles/angular";
import { AddEditOptionsDialogComponent } from "./shared/add-edit-options-dialog/add-edit-options-dialog.component";
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from "@angular-material-components/datetime-picker";
import { customErrorHandler } from "./error-handler/main";
import { NgxSpinnerModule } from "ngx-spinner";
// import { MediaModule } from "./media/media.module";
import { AsideLeftComponent } from "./theme/aside/aside-left.component";
import { ApiAuthenticationComponent } from "./views/data-source/api-authentication/api-authentication.component";
// import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
// import { NgxPermissionsModule } from "ngx-permissions";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { MenuItemComponent } from "./theme/aside/menu-item/menu-item.component";
import { OtherUtilitiesModule } from "./modules/shared/other-utilities/other-utilities.module";
import { AddEditDescriptionComponent } from "./views/pages/add-edit-description/add-edit-description.component";
import { AddPageToMenuComponent } from "./views/pages/add-page-to-menu/add-page-to-menu.component";
// import { ConfirmationComponent } from "./blogs/confirmation.component";
import { SiteCategoriesComponent } from "./views/site-categories/site-categories.component";
import { AddEditSiteCategoryComponent } from "./views/site-categories/add-edit-site-category/add-edit-site-category.component";
// import { DatepickerModule } from "skimmed-datepicker";
import { PagesFilter } from "./views/pages/pages-filter.pipe";
import { Interceptor } from "./services/interceptor.service";
import { NewDahsboardComponent } from "./views/new-dahsboard/new-dahsboard.component";
import { ActivityStatisticsComponent } from "./activity-statistics/activity-statistics.component";
import { ActivityService } from "./activity-statistics/activity-statistcs.sevices";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { SecurityComponent } from "./views/security/security.component";
import { EncryptionDecryptionIntercepter } from "./services/encryption-decryption-intercepter.service";
import { EncryptionDecryptionService } from "./services/encryption-decryption.service";
import { ContentModule } from "./modules/content/content.module";
import { AddEditMetaComponent } from "./modules/content/add-edit-meta/add-edit-meta.component";
import { LoginInfoComponent } from "./users-management/list-users/login-info/login-info.component";
import { AddEditUserWorkingHoursComponent } from "./users-management/user-working-hours/add-edit-user-working-hours/add-edit-user-working-hours.component";
import { AuthService } from "./services/auth.service";
import { PasswordHistoryComponent } from "./users-management/list-users/password-history/password-history.component";
import { UserTransactionHistoryComponent } from "./users-management/list-users/user-transaction-history/user-transaction-history.component";
import { SecurityPopUpComponent } from "./views/view-builder/security-pop-up/security-pop-up.component";
import { DatePipe } from "@angular/common";
import { MapGroupByPipe } from "./shared/filter-pipe/mapGroupBy.pipe";

import { MatCheckboxModule as MatCheckboxModule } from "@angular/material/checkbox";
// import { GestureConfig } from '@angular/material/core';
import { MatOptionModule as MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule as MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule as MatInputModule } from "@angular/material/input";
import { MatRadioModule as MatRadioModule } from "@angular/material/radio";
import { MatSelectModule as MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule as MatSnackBarModule } from "@angular/material/snack-bar";
import { MAT_CHIPS_DEFAULT_OPTIONS as MAT_CHIPS_DEFAULT_OPTIONS } from "@angular/material/chips";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { Router, RouterModule } from "@angular/router";
import { FullCalendarModule } from "@fullcalendar/angular";
import {
  FilterPageSlugsPipe,
  PagesSlugsComponent,
} from "./site-menu/pages-slugs/pages-slugs.component";
import { AddEditAliasDialogComponent } from "./views/view-builder/add-edit-alias-dialog.component";
import { PendingReviewsComponent } from "./views/statistics/pending-reviews/pending-reviews.component";
import { MostReviewedComponent } from "./views/statistics/most-reviewed/most-reviewed.component";
import { MostSearchKeyWorldsComponent } from "./views/statistics/most-search-key-worlds/most-search-key-worlds.component";
import { MostViewedProductsComponent } from "./views/statistics/most-viewed-products/most-viewed-products.component";
import { MatMenuModule } from "@angular/material/menu";
// firebase

// import { initializeApp } from 'firebase/app';
// import {  getMessaging } from 'firebase/messaging';
// import { provideFirebaseApp } from '@angular/fire/app';
// import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { environment } from "../environments/environment";
import { AsyncPipe } from "../../node_modules/@angular/common";
// import { MessagingService } from "./services/messaging.service";
import { RestrictedWordsManagementComponent } from "./views/restricted-words-management/restricted-words-management.component";
import { AddEditRestrictedWordComponent } from "./views/restricted-words-management/add-edit-restricted-word/add-edit-restricted-word.component";
// import { provideClientHydration } from "@angular/platform-browser";
import { SiteService } from "./services/site.service";

// import { AddEditUserGroupComponent } from "./users-management/user-group/add-edit-user-group/add-edit-user-group.component";

import { provideToastr, ToastrModule, ToastrService } from "ngx-toastr";
import { CustomErrorHandler } from "./error-handler/custom-error-handler";
import { MediaManagerModule } from "./modules/shared/media/media-manager/media-manager.module";
import { NewMediaModule } from "../app/new-media/new-media.module";
import { MessageService } from "primeng/api";
// import { NgCircleProgressModule } from "ng-circle-progress";
//import { FormBuilderModule } from './CP/form-builder/form-builder.module';
//import { FormBuilderModule } from '../app/new-media/new-media.module';
import { AddEditUserGroupComponent } from "./users-management/user-group/add-edit-user-group/add-edit-user-group.component";
import { LoggerComponent } from "./views/logger/logger.component";
import { VcrOutletComponent } from "./views/view-builder/vcr-outlet.component";

// import { MediaDialogComponent } from './new-media/new-media-manager/media-dialog/media-dialog.component';
// import { provideClientHydration } from '@angular/platform-browser';
// firebase
// import { NewsLetterComponent } from './news-letter/news-letter.component';
//import { AddEditFolderComponent } from './new-media/new-media-manager/folders/add-edit-folder/add-edit-folder.component';
// import { SafePipe } from './shared/filter-pipe/safe.pipe';
//import {TagInputModule} from 'ngx-chips'

export function createCompiler(compilerFactory: CompilerFactory) {
  return compilerFactory.createCompiler();
}

export function filter(req: HttpRequest<any>): boolean {
  return (
    req.url.includes("General/CheckSiteSlug") ||
    req.url.includes("ApiInvoker/AddEditApiMapperParams") ||
    req.url.includes("/users/QuickSearch") ||
    req.url.includes("/users/GetAll") ||
    req.url.includes("token")
  );
}

@NgModule({
  declarations: [
    AppComponent,
    LoggerComponent,
    TranslationComponent, //abdullah nassar
    PagesSlugsComponent,
    FilterPageSlugsPipe,
    SecurityComponent,
    ActivityStatisticsComponent,
    AddEditDescriptionComponent,

    AddEditAliasDialogComponent,
    MainComponent,
    LoginComponent,
    PageTemplatesComponent,
    AddEditPageTemplateComponent,
    PagesComponent,
    AddEditMetaComponent,
    AddPageToMenuComponent,
    SettingComponent,
    AddEditPageComponent,
    MediaManagerComponent,
    AddFolderDialogComponent,
    ViewFileComponent,
    DuplicatedFileComponent,
    ReleaseManagerComponent,
    AddPageTitleComponent,
    BlogsArticlesComponent,
    AddEditBlogComponent,
    AddEditBlogCategoryComponent,
    UsersPermissionsComponent,
    PermissionsComponent,
    AddEditRolesComponent,
    MenusComponent,
    AddEditMenuComponent,
    ChildsMenuComponent,
    DashboardComponent,
    ConfirmModalComponent,
    // MediaDialogComponent,
    // ConfirmDirective,
    SiteThemesComponent,
    ThemeDetailsComponent,
    AddEditThemeNameComponent,
    DataSourceComponent,
    AddEditDataSorceComponent,
    RolesManagerComponent,
    // RolePermissionDirective,
    Error_403Component,
    RolesDialogeComponent,
    ThemeCalenderComponent,
    ComponentPageComponent,
    ComponentsTemplatesComponent,
    ComponentsPrewiewComponent,
    AddEditComponentComponent,
    CompilerComponent,
    AppPageChildsMenuComponent,
    // SanitizeHtmlPipe,
    AddContainerComponent,
    AddRowComponent,
    BlockSettingsComponent,
    SummernoteComponent,
    TestDatasourceComponent,
    EmailTemplateComponent,
    AddEditEmailTemplateComponent,
    NotificationsComponent,
    AddNotificationsComponent,
    SubmitFormsComponent,
    ViewBuilderComponent,
    VcrOutletComponent,
    ComponentPositioningComponent,
    NewDahsboardComponent,
    SubmittedFormsComponent,
    AdvanceSearchDialogComponent,
    ApiAuthenticationComponent,
    AsideLeftComponent,
    MenuItemComponent,
    // ConfirmationComponent,
    SiteCategoriesComponent,
    AddEditSiteCategoryComponent,
    PagesFilter,
    LoginInfoComponent,
    AddEditUserGroupComponent,
    AddEditUserWorkingHoursComponent,
    PasswordHistoryComponent,
    UserTransactionHistoryComponent,
    SecurityPopUpComponent,
    MapGroupByPipe,
    PendingReviewsComponent,
    MostReviewedComponent,
    MostSearchKeyWorldsComponent,
    MostViewedProductsComponent,
    RestrictedWordsManagementComponent,
    AddEditRestrictedWordComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    FormsModule,
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    TypeaheadModule.forRoot(),
    // HighchartsChartComponent,
    //HighchartsChartComponent,
    // ChartsModule,
    MatOptionModule,
    // CommonSettingLibModule,
    MatDialogModule,
    MatMenuModule,
    AceEditorModule,
    // TagInputModule,
    // NgxParticlesModule,
    // ParticlesModule,
    TimepickerModule.forRoot(),
    // GridsterModule,
    MatSelectModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    // NgDragDropModule.forRoot(),
    AppRoutingModule,
    TextFieldModule,
    FullCalendarModule,
    RouterModule,
    FontAwesomeModule,
    // ResizableModule,
    BlockUIModule.forRoot(),
    BlockUIHttpModule.forRoot({ requestFilters: [filter] }),
    ConfirmationPopoverModule.forRoot({}),
    PopoverModule.forRoot(),
    AngularEditorModule,
    ColorPickerModule,
    NgxDropzoneModule,

    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot(),
    MaterialModule,
    SharedModule,
    MatExpansionModule,
    // FlexLayoutModule,
    DragDropModule,
    // NgxNewstickerAlbeModule,
    TabsModule.forRoot(),
    MatCheckboxModule,

    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSnackBarModule,
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    MatTableModule,
    // NgxImageEditorModule,
    NgxSummernoteModule,
    MomentModule,

    NgIdleKeepaliveModule.forRoot(),
    // CustomFormsModule,
    AccordionModule.forRoot(),
    NgSelectModule,

    CookieModule.forRoot(),
    // NgxDaterangepickerMd.forRoot(),
    AngularMultiSelectModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxSpinnerModule,
    MediaManagerModule,
    // NewMediaModule,
    // PerfectScrollbarModule,
    // NgxPermissionsModule,
    NgbTooltipModule,
    OtherUtilitiesModule,
    // DatepickerModule,
    ContentModule,
    NewMediaModule,
    // NgCircleProgressModule.forRoot({}),
    //FormBuilderModule
  ],
  providers: [
    provideClientHydration(),
    ModuleService,
    LoginActivate,
    RoleGuard,
    MessageService,
    CanDeactivateGuard,
    AuthService,
    DatePipe,
    CookieService,
    CookieModule,
    MapGroupByPipe,
    // MessagingService,
    AsyncPipe,
    ToastrService,
    provideToastr({
      timeOut: 10000,
      positionClass: "toast-bottom-right",
      closeButton: true,
      toastClass: "toaster-bar",
      tapToDismiss: true,
      messageClass: "toaster-message",
      progressBar: true,
    }),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncryptionDecryptionIntercepter,
      multi: true,
    },

    // EncryptionDecryptionIntercepter,
    // Interceptor,
    // {
    //   provide: HAMMER_GESTURE_CONFIG,
    //   useClass: GestureConfig,
    // },
    {
      provide: COMPILER_OPTIONS,
      useValue: {},
      multi: true,
    },
    // {
    //   provide: CompilerFactory,
    //   useClass: JitCompilerFactory,
    //   deps: [COMPILER_OPTIONS],
    // },
    // {
    //   provide: Compiler,
    //   useFactory: createCompiler,
    //   deps: [CompilerFactory],
    // },
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        separatorKeyCodes: [ENTER, COMMA],
      },
    },
    {
      provide: "SnotifyToastConfig",
      useValue: ToastDefaults,
    },
    SnotifyService,
    ActivityService,
    SiteService,
    //EncryptionDecryptionService,
    // provideClientHydration(),
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
